/*
 payment/lib/external-panel-and-window-handler.js
 */

import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view';

const register = dataflow.register;
const state = {
	pending: false
};

function viewUpdate() {
	view.update({
		external_panel_and_window_handler: state
	});
}

function addInputFromObjectToForm(form, paramsObject) {
	jQuery.each(paramsObject, (name, value) => {
		let $input = null;
		if (name === 'method') {
			return;
		}
		$input = jQuery('<input>').attr({
			type: 'hidden',
			name,
			value
		});
		form.append($input);
	});
}

function showProviderContentInMainWindowByPost(providerUrl, parametersToProviderUrl) {
	const target = '_self';
	const form = jQuery('<form>').attr({
		action: providerUrl,
		method: 'POST',
		target,
		id: 'postToIframeForm'
	});
	if (parametersToProviderUrl) {
		addInputFromObjectToForm(form, parametersToProviderUrl);
	}
	jQuery(document.body).append(form);
	form.submit().remove();
}

function showProviderContentInMainWindowByGet(providerUrl, parametersToProviderUrl) {
	const urlWithParameters = createUrlWithParameters(providerUrl, parametersToProviderUrl);
	top.location = urlWithParameters;
}

function createUrlWithParameters(url, parameters) {
	let character;
	if (url.indexOf('?') > -1) {
		character = '&';
	} else {
		character = '?';
	}

	const urlWithParameters = url + character + jQuery.param(parameters);
	return urlWithParameters;
}

function registerActions() {
	function externalPanelAndWindowHandler(payload) {
		let sendHandlerData;
		let externalParameters;
		let externalUrl;
		const methodFunction = {
			post: showProviderContentInMainWindowByPost,
			get: showProviderContentInMainWindowByGet
		};
		const defaultMethod = {
			method: 'get'
		};

		if (payload.type === constants.SUBMIT_PAYMENT) {
			/* the handling of the submit and result is filtered by sendHandlerType */
			if (payload && (payload.sendHandlerType === constants.EXTERNAL_PANEL || payload.sendHandlerType === constants.EXTERNAL_WINDOW)) {
				state.pending = true;
				viewUpdate();
				sendHandlerData = payload.sendHandlerData; // what to do with this?
				if (sendHandlerData.handler) {
					externalParameters = sendHandlerData.handler.externalParameters;
					externalUrl = sendHandlerData.handler.externalUrl;
				} else {
					externalParameters = sendHandlerData.externalParameters;
					externalUrl = sendHandlerData.externalUrl;
				}
				/* spinner is displayed from the connected view */
				state.pending = false;
				viewUpdate();

				externalParameters = jQuery.extend(defaultMethod, externalParameters);

				methodFunction[externalParameters.method](externalUrl, externalParameters);

			}
		}
	}
	register(externalPanelAndWindowHandler);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/external-panel-and-window-handler.js